import React from "react"
import { FormControlLabel, FormControlLabelProps } from "@material-ui/core"

export const KyrFormControlLabel = (props: FormControlLabelProps) => {
    return (
        <FormControlLabel {...props} style={{marginRight: '6px', ...props.style}} />
    )
}